module.exports = __webpack_public_path__ + "static/media/yourlogo.e008e2e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/yourlogo.png
// module id = 1223
// module chunks = 0